export enum CompensationType {
  Monthly = 'Monthly',
  Hourly = 'Hourly',
  Biweekly = 'Biweekly',
  Yearly = 'Yearly',
}
